import styled from 'styled-components'

import { mainColors } from '@avantstay/backoffice-core'

export const IndependentContainer = styled.div<{ isOpen: boolean; isNavigating?: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  width: 400px;
  height: 100vh;
  background: ${mainColors.white};
  border-left: 1px solid ${mainColors.neutralMedium};
  z-index: 9999;
  transform: translateX(${props => (props.isOpen ? '0' : '100%')});
  transition: ${props =>
    props.isNavigating ? 'none' : 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)'};
  box-shadow: ${props => (props.isOpen ? '-2px 0 20px rgba(0,0,0,0.15)' : 'none')};
  opacity: ${props => (props.isOpen ? '1' : '0')};

  .glossary-highlight {
    animation: highlightPulse 3s ease-in-out;
  }

  @keyframes highlightPulse {
    0% {
      background-color: rgba(59, 130, 246, 0.3);
    }
    50% {
      background-color: rgba(59, 130, 246, 0.15);
    }
    100% {
      background-color: transparent;
    }
  }

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  color: ${mainColors.neutralDark};
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  transition: all 0.2s ease;

  &:hover {
    background: ${mainColors.neutralLight};
    color: ${mainColors.neutralExtremelyDark};
  }
`

export const Header = styled.div<{ isOpen?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 60px 20px 0 20px;
  margin-bottom: 16px;
  animation: ${props => (props.isOpen ? 'fadeInDown 0.4s ease-out 0.1s both' : 'none')};
`

export const Title = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${mainColors.black};
  margin: 0;
  letter-spacing: -0.01em;
`

export const SearchContainer = styled.div<{ isExpanded: boolean }>`
  display: flex;
  align-items: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  width: ${props => (props.isExpanded ? '250px' : '32px')};
  height: 32px;
  background: ${props => (props.isExpanded ? mainColors.white : 'transparent')};
  border: ${props => (props.isExpanded ? `1px solid ${mainColors.neutralMedium}` : 'none')};
  border-radius: 6px;
  position: relative;
  box-shadow: ${props => (props.isExpanded ? '0 2px 4px rgba(0,0,0,0.1)' : 'none')};

  &:hover {
    border-color: ${props => (props.isExpanded ? mainColors.neutralDark : 'transparent')};
  }
`

export const SearchIconButton = styled.button<{ isExpanded?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  color: ${props => (props.isExpanded ? mainColors.accentMedium : mainColors.neutralDark)};
  transition: all 0.2s ease;
  border-radius: 6px;
  flex-shrink: 0;
  transform: ${props => (props.isExpanded ? 'rotate(90deg)' : 'rotate(0deg)')};

  &:hover {
    background: ${mainColors.neutralLight};
    color: ${props => (props.isExpanded ? mainColors.accentDark : mainColors.neutralExtremelyDark)};
    transform: ${props =>
      props.isExpanded ? 'rotate(90deg) scale(1.05)' : 'rotate(0deg) scale(1.05)'};
  }

  &:active {
    transform: ${props =>
      props.isExpanded ? 'rotate(90deg) scale(0.95)' : 'rotate(0deg) scale(0.95)'};
  }

  svg {
    width: 24px;
    height: 24px;
    transition: transform 0.2s ease;
  }
`

export const SearchInputContainer = styled.div<{ isVisible: boolean }>`
  opacity: ${props => (props.isVisible ? '1' : '0')};
  transform: translateX(${props => (props.isVisible ? '0' : '-10px')});
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: ${props => (props.isVisible ? '0.1s' : '0s')};
  width: 100%;

  .search-input-wrapper {
    border: none !important;
    background: transparent !important;

    input {
      border: none !important;
      background: transparent !important;
      padding: 8px !important;
      font-size: 14px;

      &:focus {
        outline: none !important;
        box-shadow: none !important;
      }
    }
  }
`
